export const Logo = ({ className = "", variant = "oro", size = "h-6 sm:h-7" }) => (
  <img data-testid="brand-logo" src={`/brand/logo-${variant}.png`} alt="Skin Lovers Professional"
    className={`${size} w-auto select-none ${className}`} draggable={false} />
);
